/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { _initialState } from '../_initialState';

export default (set, get) => {

  return set(produce(get(), (draft) => {
    if (!draft.design) {
      draft.design = {};
    }
    draft.design.cart = _initialState.design.cart;
  }), false, { type: 'RESET_CART' });
};
